<div
  *ngIf="
    inputRegisteredAction.asset == null && inputRegisteredAction.type == null
  "
  class="d-flex"
>
  <div>
    <i>{{ printDate() }}</i>
  </div>
  <div class="flexer-3">
    <i> {{ printUser() }}</i>
  </div>
</div>
<div *ngIf="inputRegisteredAction.asset != null" class="d-flex">
  <div class="flex-1">
    <i>{{ printDate() }}</i>
  </div>
  <div class="flex-1">
    <i>{{ printUser() }}</i>
  </div>
  <div class="flex-1-5">
    <a
      class="click-link"
      download="{{ inputRegisteredAction.asset.name }}"
      href="/api/assets/generated/{{ inputRegisteredAction.asset.uuid }}"
    >
      <i>{{ inputRegisteredAction.asset.name }}</i>
    </a>
  </div>
</div>
<div *ngIf="inputRegisteredAction.type != null" class="d-flex">
  <div class="flex-1">
    <i>{{ printDate() }}</i>
  </div>
  <div class="flex-1">
    <i>{{ printUser() }}</i>
  </div>
  <div class="flex-1-5">
    <i>{{ inputRegisteredAction.type.label }}</i>
  </div>
</div>
